import i18n from "src/i18n/config";
import { z } from "zod";

import { parseLines } from "./AdminOauthClientPage.utils";

const nonEmptyLines = () =>
    z
        .string(i18n.t("common:validation.fieldRequired"))
        .refine((value) => parseLines(value).length > 0, i18n.t("pages:adminOauthClientsPage.validation.atLeastOneRequired"));

export const ClientValidationSchema = z.object({
    clientId: z.string(i18n.t("common:validation.fieldRequired")).min(1, i18n.t("common:validation.fieldRequired")),
    displayName: z.string(i18n.t("common:validation.fieldRequired")).min(1, i18n.t("common:validation.fieldRequired")),
    clientSecret: z.string(i18n.t("common:validation.fieldRequired")).optional(),
    clientType: z.string(i18n.t("common:validation.fieldRequired")).min(1, i18n.t("common:validation.fieldRequired")),
    redirectUris: nonEmptyLines(),
    postLogoutRedirectUris: nonEmptyLines(),
    permissions: nonEmptyLines(),
    requirements: z.string().optional(),
});
